import React from 'react';
import { BaseLayerView } from '@/framework';
import { IRenderLayerProps } from '@/version-types';
import BrushImage from './brush-image';

const BrushLayer: React.FC<IRenderLayerProps> = (args) => {
    const { layer, isNavigator } = args;
    return (
        <BaseLayerView layer={layer} isNavigator={isNavigator}>
            <BrushImage {...args} />
        </BaseLayerView>
    );
};
export default React.memo(BrushLayer);
